import { render } from "./gNinePaymentModel.vue?vue&type=template&id=33734bc2"
import script from "./gNinePaymentModel.vue?vue&type=script&lang=js"
export * from "./gNinePaymentModel.vue?vue&type=script&lang=js"

import "./gNinePaymentModel.vue?vue&type=style&index=0&id=33734bc2&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__